export default {
  username: '',
  password: '',
}